import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function ProofSection() {
  return <SectionWrapper narrow data-id="element-95">
      <div className="text-center space-y-6" data-id="element-96">
        <h2 className="text-3xl font-heading font-bold text-primary" data-id="element-97">
          Lo que cambia en 7 días
        </h2>

        <p className="text-xl text-secondary font-body leading-relaxed" data-id="element-98">
          No verás un hijo perfecto, pero verás un hijo que ya no necesita
          gritar para defenderse. Verás una disminución del 70% en la intensidad
          de las discusiones y, por primera vez en meses, tendrás una charla de
          más de dos minutos que no termine en conflicto.
        </p>
      </div>
    </SectionWrapper>;
}